import { useEffect, useState, useContext } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";
import FetchUtil from "../utils/FetchUtil";
import UserContext from "../contexts/UserContext";

let locationOptions = [];
let subsidiaryOptions = [];

function SubsidiaryLocationTableRow({ index, userSubsidiaries, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [userSubsidiaryLoaded, setUserSubsidiaryLoaded] = useState(false);
	const [userSubsidiarySelected, setUserSubsidiarySelected] = useState({ name: "subsidiaryKey", label: "", value: 0 });
	const [locationLoaded, setLocationLoaded] = useState(false);
	const [locationSelected, setLocationSelected] = useState({ name: "locationKey", label: "", value: 0 });
	const [isSubmit, setIsSubmit] = useState(false);
	const [isLocationLoading, setIsLocationLoading] = useState(false);
	const userCtx = useContext(UserContext);
	
	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		setUserSubsidiaryValues(userSubsidiaries);
	}, []);

	function setUserSubsidiaryValues(subsidiaryObj) {
		let subsidiaryValue = {};
		subsidiaryOptions = [];
		if (subsidiaryObj && subsidiaryObj.length > 0) {
			subsidiaryObj.map((aSubsidiary, idx) => {

				subsidiaryValue.label = aSubsidiary.companyName;
				subsidiaryValue.value = aSubsidiary.companyId;
				subsidiaryOptions.push(subsidiaryValue);
				subsidiaryValue = {};
			});
			setUserSubsidiaryLoaded(true);
		}
	}
	const subsidiaryHandler = (selectedOption, action) => {
		let subsidiaryKey = selectedOption ? selectedOption.value : 0;
		let subsidiaryLabel = selectedOption ? selectedOption.label : "";
		setUserSubsidiarySelected({ ...userSubsidiarySelected, label: (subsidiaryLabel), value: subsidiaryKey });
		fetchSubsidiaryLocations(subsidiaryKey);
	}
	const locationHandler = (selectedOption, action) => {
		let locationKey = selectedOption ? selectedOption.value : 0;
		let locationName = selectedOption ? selectedOption.label : "";
		setLocationSelected({ ...locationSelected, label: (locationName), value: locationKey });
	}

	function fetchSubsidiaryLocations(subsidiaryKey) {
		setError("");
		if (!subsidiaryKey || subsidiaryKey === 0) {
			return;
		}

		setIsLocationLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false,
				companyId: subsidiaryKey,
				userCompanyId : userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetWorkLocations", "/Service/CompanyService/GetWorkLocations", requestOptions, retrieveWorkLocationSuccess, retrieveWorkLocationFail);
		} catch (error) {
			setIsLocationLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveWorkLocationFail(redirect) {
		setIsLocationLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.locNotRetrieved"));
	}

	function retrieveWorkLocationSuccess(responseData) {
		let fetchWorkLocationsResponse;
		if (responseData) {
			fetchWorkLocationsResponse = responseData.fetchWorkLocationsResponse;
			if (fetchWorkLocationsResponse && fetchWorkLocationsResponse.errorCode === "0") {
				setLocationValues(fetchWorkLocationsResponse.locations.slice());
			} else if (fetchWorkLocationsResponse && fetchWorkLocationsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchWorkLocationsResponse) {
				setError(t("error.error") + " " + fetchWorkLocationsResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsLocationLoading(false);
	}

	function setLocationValues(locationObj) {
		let locationValue = {};
		locationOptions = [];
		locationOptions.push({ label: "", value: 0 });
		if (locationObj && locationObj.length > 0) {
			locationObj.map((aLoc, idx) => {
				locationValue.label = aLoc.locationName + "-" + aLoc.departmentName;
				locationValue.value = aLoc.locationKey;
				locationOptions.push(locationValue);
				locationValue = {};
			});
			setLocationLoaded(true);
		}
	}


	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let initialValues = {
			locationKey: locationSelected.value,
			subsidiaryCompanyId: userSubsidiarySelected.value
		};

		if (!userSubsidiarySelected.value || userSubsidiarySelected.value === 0) {
			setError(t("error.subsidiaryReqd"));
			setIsSubmit(false);
		} else if (!locationSelected.value || locationSelected.value === 0) {
			setError(t("error.locNameReqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{userSubsidiaryLoaded ? <Select
					name="subsidiaryKey"
					options={subsidiaryOptions}
					onChange={subsidiaryHandler}
					placeholder={""}
					value={userSubsidiarySelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="subsidiaryKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{locationLoaded ? <Select
					name="locationKey"
					options={locationOptions}
					onChange={locationHandler}
					placeholder={""}
					value={locationSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="locationKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(locationOptions && locationOptions.length >0 && subsidiaryOptions && subsidiaryOptions.length >0) ?
				(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>) 
				:
				(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default SubsidiaryLocationTableRow;